import React from "react";
import { Typography } from "@material-tailwind/react";
import { Link, useLocation } from "react-router-dom";

const currentYear = new Date().getFullYear();

const THEMED_PAGES = ['/portfolio', '/about', '/contact'];

const Footer = () => {
  const location = useLocation();
  const isBlogPage = location.pathname.includes('/blog');
  const isIndexPage = location.pathname === '/';
  const isThemedPage = THEMED_PAGES.includes(location.pathname) || location.pathname.startsWith('/about/') || location.pathname.startsWith('/portfolio') || isBlogPage;

  // Determine footer styling based on page context
  const footerClasses = isIndexPage || isThemedPage
      ? "relative w-full bg-slate-900/50 border-t border-accent/10 py-12 px-4"
      : "relative w-full bg-gradient-to-b from-gray-800 via-gray-900 to-black border-t border-gray-700";

  const brandTextClasses = "text-slate-100 font-semibold tracking-wider text-lg";

  const linkClasses = isIndexPage
      ? "text-slate-400 hover:text-accent transition-colors text-sm font-bold uppercase tracking-widest"
      : isThemedPage
        ? "text-slate-400 hover:text-accent transition-colors text-sm font-medium relative group"
        : "text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group";

  const underlineClasses = isThemedPage
      ? "absolute -bottom-1 left-0 w-0 h-0.5 bg-accent transition-all duration-300 group-hover:w-full"
      : "absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 transition-all duration-300 group-hover:w-full";

  const dotClasses = isThemedPage
      ? "w-2 h-2 bg-accent rounded-full"
      : "w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full";

  const lineClasses = isThemedPage
      ? "w-24 h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent"
      : "w-24 h-px bg-gradient-to-r from-transparent via-gray-500 to-transparent";

  const copyrightClasses = isIndexPage || isThemedPage
      ? "font-mono text-[10px] text-slate-600"
      : "text-gray-400 text-xs font-medium tracking-wider";

  return (
    <footer className={footerClasses}>
      <div className={isIndexPage || isThemedPage ? "max-w-screen-md mx-auto flex flex-col items-center gap-8" : "container mx-auto px-6 py-8"}>
        <div className="flex flex-col items-center justify-center text-center space-y-6">
          {!isIndexPage && (
            <div className="flex items-center space-x-2">
              <div className={dotClasses}></div>
              <Typography as="span" className={brandTextClasses}>
                Andy Cary
              </Typography>
              <div className={dotClasses}></div>
            </div>
          )}

          {/* Navigation Links */}
          <nav className={isIndexPage || isThemedPage ? "flex gap-8" : "flex items-center justify-center space-x-8"}>
            {isIndexPage ? (
              <>
                <a
                  href="https://github.com/acary"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClasses}
                >
                  GitHub
                </a>
                <a
                  href="https://www.linkedin.com/in/andrewdcary/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={linkClasses}
                >
                  LinkedIn
                </a>
                <Link to="/contact" className={linkClasses}>
                  Email
                </Link>
              </>
            ) : (
              <>
                <Link to="/about" className={linkClasses}>
                  About
                  <span className={underlineClasses}></span>
                </Link>
                <Link to="/portfolio" className={linkClasses}>
                  Portfolio
                  <span className={underlineClasses}></span>
                </Link>
                <Link to="/blog" className={linkClasses}>
                  Blog
                  <span className={underlineClasses}></span>
                </Link>
                <Link to="/contact" className={linkClasses}>
                  Contact
                  <span className={underlineClasses}></span>
                </Link>
              </>
            )}
          </nav>

          {!isIndexPage && <div className={lineClasses}></div>}

          {/* Copyright */}
          <p className={copyrightClasses}>
            &copy; {currentYear} Andy Cary
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
